export const showDebugLogs = false;
export const runDebugFunctions = false;
export const inDevelopment = process.env.NODE_ENV === "development";
export const USE_HARDCODED_SUBSCRIPTION_PRICES = true;
